export default "__VITE_ASSET__Dy6_2fGm__"